import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const getToken = () => {
  const rawToken =
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("token");

  if (!rawToken) {
    throw new Error("Token nao encontrado.");
  }

  return rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
};

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

const getApiErrorMessage = (err, fallbackMessage) => {
  const responseData = err?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) return responseData;
  if (responseData?.message) return responseData.message;
  if (responseData?.erro) return responseData.erro;
  if (responseData?.detail) return responseData.detail;

  return err?.message || fallbackMessage;
};

const getResumo = async () => {
  const response = await axios.get(`${baseURL}/notificacoes/resumo`, {
    headers: authHeaders(),
  });

  return {
    naoLidas: Number(response?.data?.naoLidas || 0),
  };
};

const listar = async ({ limit = 20, offset = 0 } = {}) => {
  const response = await axios.get(`${baseURL}/notificacoes`, {
    headers: authHeaders(),
    params: { limit, offset },
  });

  return {
    itens: Array.isArray(response?.data?.itens) ? response.data.itens : [],
    limit: response?.data?.limit ?? limit,
    offset: response?.data?.offset ?? offset,
  };
};

const marcarComoLida = async (idNotificacao) => {
  const encodedId = encodeURIComponent(idNotificacao);
  const response = await axios.patch(`${baseURL}/notificacoes/lida?idNotificacao=${encodedId}`, null, {
    headers: authHeaders(),
  });

  return response;
};

const marcarTodasComoLidas = async () => {
  const response = await axios.patch(`${baseURL}/notificacoes/lidas`, null, {
    headers: authHeaders(),
  });

  return response;
};

const notificacoesService = {
  getApiErrorMessage,
  getResumo,
  listar,
  marcarComoLida,
  marcarTodasComoLidas,
};

export default notificacoesService;
